import http from '@/utils/http'
import httpApi from '@/apis/httpApi'
export const getLog = (id, ip) => {
  return http.get({
    url: httpApi.debugModel.getLog,
    data: {
      target: `${id}_${ip}`,
    },
  })
}
